import SettingsIcon from '@mui/icons-material/Settings';
import { Box, Button, Typography } from '@mui/material';
import moment from 'moment';
import { Link } from 'src/components/UI';
import Icon from 'src/components/UI/CustomUI/atoms/Icon';
import {
  AlignType, HeaderType
} from 'src/components/UI/CustomUI/organisms/Table/types';

import styles from './styles.module.scss';

export const removeProtocol = (url: string): string => {
  if (!url) {
    return ''
  }

  return url.replace(/(^\w+:|^)\/\//, '')
}

const applyRegExp = (phone: string): string => {
  if (!phone) return ''

  return String(phone).replace(/^(\d{3})(\d{3})(\d{4})$/g, '+1 $1-$2-$3')
}

const headers: HeaderType[] = [
  // {
  //   id: 'affiliateId',
  //   label: 'Affiliate ID',
  //   custom: true,
  //   align: 'left' as AlignType,
  //   Element: (row: any): JSX.Element => {
  //     return (
  //       <Box padding="2px 10px">
  //         <Typography className={styles.Contractors__contractorName}>
  //           {row?.affiliateId}
  //         </Typography>
  //       </Box>
  //     )
  //   },
  // },
  {
    id: 'contractorName',
    label: 'Contractor Name',
    custom: true,
    align: 'left' as AlignType,
    Element: (row: any): JSX.Element => {
      return (
        <Box padding="2px 10px">
          <Typography className={styles.Contractors__contractorName}>
            {row?.name}
          </Typography>
        </Box>
      )
    },
  },
  {
    id: 'firstName',
    label: 'First Name',
    custom: true,
    align: 'center' as AlignType,
    Element: (row: any): JSX.Element => {
      return (
        <Box padding="2px 10px">
          <Typography className={styles.Contractors__createdOn}>
            {row.firstName}
          </Typography>
        </Box>
      )
    },
  },
  {
    id: 'lastName',
    label: 'Last Name',
    custom: true,
    align: 'center' as AlignType,
    Element: (row: any): JSX.Element => {
      return (
        <Box padding="2px 10px">
          <Typography className={styles.Contractors__createdOn}>
            {row.lastName}
          </Typography>
        </Box>
      )
    },
  },
  {
    id: 'territory',
    label: 'Territory',
    custom: true,
    align: 'center' as AlignType,
    Element: (row: any): JSX.Element => {
      return (
        <Box padding="2px 10px">
          <Typography className={styles.Contractors__createdOn}>
            {row.territory}
          </Typography>
        </Box>
      )
    },
  },
  {
    id: 'websiteUrl',
    label: 'Website URL',
    custom: true,
    align: 'left' as AlignType,
    Element: (row: any): JSX.Element => {
      return (
        <Box padding="2px 10px">
          <Link
            href={row.websiteUrl}
            target="_blank"
            style={{ textDecoration: 'none' }}
          >
            <Box
              gap="4px"
              display="flex"
              borderBottom="1px solid var(--blue700)"
              width="fit-content"
            >
              <Typography
                className={styles.Contractors__contractorName}
                style={{ color: 'var(--blue700)' }}
              >
                {(row.websiteUrl)}
              </Typography>
              <Icon
                sx={{ color: '#3A66FF', width: 'fit-content' }}
                name="NorthEast"
                height="14px"
              />
            </Box>
          </Link>
        </Box>
      )
    },
  },

  {
    id: 'docuSignLink',
    label: 'DocuSign Link',
    custom: true,
    width: 400,
    maxWidth: 400,
    align: 'left' as AlignType,
    Element: (row: any): JSX.Element => {
      return (
        <Box padding="2px 10px">
          <Link
            href={row.docuSignLink}
            target="_blank"
            style={{ textDecoration: 'none' }}
          >
            <Box
              gap="4px"
              display="flex"
              borderBottom="1px solid var(--blue700)"
              width="fit-content"
            >
              <Typography
                className={styles.Contractors__contractorName}
                style={{ color: 'var(--blue700)' }}
              >
                {(row.docuSignLink)}
              </Typography>
              <Icon
                sx={{ color: '#3A66FF', width: 'fit-content' }}
                name="NorthEast"
                height="14px"
              />
            </Box>
          </Link>
        </Box>
      )
    },
  },
  {
    id: 'email',
    label: 'Email',
    custom: true,
    align: 'left' as AlignType,
    Element: (row: any): JSX.Element => {
      return (
        <Box padding="2px 10px">
          <Typography className={styles.Contractors__contractorName}>
            {row.email}
          </Typography>
        </Box>
      )
    },
  },
  {
    id: 'active',
    label: 'Active',
    custom: true,
    maxWidth: 80,
    Element: (row: any): JSX.Element => {
      return row?.active ? <Icon name='CheckCircle' color="var(--success-color)" /> : <Icon color="var(--error-color)" name='Cancel' />
    }
  },
  {
    id: 'settings',
    label: 'Settings',
    custom: true,
    align: 'center' as AlignType,
    Element: (row: any): JSX.Element => {
      const { handleSettings, ...duckContractor } = row
      return (
        <Button
          onClick={() => { row.handleSettings(duckContractor) }}
          variant="containedLight"
          className={styles.Contractors__viewButton}
          color="primary"
          style={{
            width: '107px',
            height: '46px'
          }}
          startIcon={<SettingsIcon color='inherit' fontSize='small' />}
        >
          Settings
        </Button>
      )
    }
  },
  // {
  //   id: 'action',
  //   label: 'Action',
  //   custom: true,
  //   align: 'left' as AlignType,
  //   Element: (row: any): JSX.Element => {
  //     return (
  //       <Link href={`/contractors/${row.id}`} style={{ textDecoration: 'none' }}>
  //         <Box display="flex" justifyContent="center" alignItems="center">
  //           <Button
  //             variant="contained"
  //             className={styles.Contractors__viewButton}
  //             endIcon={
  //               <Icon
  //                 color="inherit"
  //                 name="NorthEast"
  //                 width="1rem"
  //                 height="12px"
  //               />
  //             }
  //           >
  //             View
  //           </Button>
  //         </Box>
  //       </Link>
  //     )
  //   },
  // },
]

export default headers
